import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useSchemaInvoiceGroupAccount = () => {
  const { t } = useTranslation(['invoice']);

  const optionalAccountField = yup
    .string()
    .optional()
    .matches(/^\d*$/, t('invoice:adminInvoiceGroupAccountingTab.validationNumbersOnly'))
    .max(6, t('invoice:adminInvoiceGroupAccountingTab.validationMaxLength'));

  const invoiceGroupAccountSchema = yup.object().shape({
    bankAccount: optionalAccountField,
    memberAccount: optionalAccountField,
    depositAccount: optionalAccountField,
    fsPayServiceAccount: optionalAccountField,
    voucherSerie: yup.string().optional(),
    eventAccount: optionalAccountField,
    buyAccount: optionalAccountField,
    clearingSwishAccount: optionalAccountField,
    clearingStripeAccount: optionalAccountField,
  });
  return invoiceGroupAccountSchema;
};
